import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// static
import ArchiveIconOrigin from 'src/icons/archive.svg'
// utils
import { size } from 'polished'

export const Wrapper = styled.div`
  margin-top: 20px;
`

export const ArchiveIcon = styled(ArchiveIconOrigin)`
  && {
    ${size('14px')};

    margin-left: auto;
    min-width: 14px;

    path {
      fill: ${colors.darkBlue400};
    }
  }
`
